import { Routes } from '@router/routes';

export const POLICY_LINKS = [
  {
    id: 1,
    name: 'Privacy policy',
    path: Routes.NOT_FOUND,
  },
  {
    id: 2,
    name: 'Terms of us',
    path: Routes.NOT_FOUND,
  },
];
